import type { TResponseBase } from '../../types'
import UserControllerBase from '../base'
import type { PrivateDataAccessRequest } from '../types'
import type { NAnswerRequest, NCreateRequest } from './types'

export default class PrivateDataAccessController extends UserControllerBase {
  static readonly controllerPath = 'privatedataaccess'
  private readonly serviceUrl: string

  constructor() {
    super(PrivateDataAccessController.controllerPath)
    this.serviceUrl = this.getFullServiceUrl()
  }

  async getRequest(requestId: string): TResponseBase<PrivateDataAccessRequest> {
    return await useFetchInstance(`${this.serviceUrl}/request/${requestId}`, {
      method: 'GET',
    })
  }

  async shouldObfuscate(
    organizationId: string,
    userId: string,
  ): TResponseBase<boolean> {
    return await useFetchInstance(
      `${this.serviceUrl}/${organizationId}/${userId}/shouldobfuscate`,
      {
        method: 'GET',
      },
    )
  }

  async createRequest(
    body: NCreateRequest.IBody,
  ): TResponseBase<PrivateDataAccessRequest> {
    return await useFetchInstance(`${this.serviceUrl}/request`, {
      method: 'POST',
      body,
    })
  }

  async answerRequest(
    requestId: string,
    body: NAnswerRequest.IBody,
  ): TResponseBase<PrivateDataAccessRequest> {
    return await useFetchInstance(`${this.serviceUrl}/request/${requestId}`, {
      method: 'PATCH',
      body,
    })
  }
}
